import { Box } from '@mui/system'
import React from 'react'
import { Feeds } from '../components/Feeds'
export const Feed = () => {
  return (
    <Box flex={4} padding={2}>

  <Feeds/>
  <Feeds/>
  <Feeds/>
  <Feeds/>
  <Feeds/>
  <Feeds/>
  <Feeds/>
  <Feeds/>
  <Feeds/>
  <Feeds/>

    </Box>
  )
}
